export interface ConsentDTO {
  id: number;
  consentType: ConsentTypeEnum;
  content: string;
}

export interface ConsentLinksDTO {
  gdprUrl: string;
  termsUrl: string;
  privacyPolicyUrl: string;
}

export enum ConsentTypeEnum {
  GDPR = 1,
  MyBenefitsTerms = 2,
  PrivacyPolicy = 3
}
